<template>
<div class="chapter">
<div class="inner_page">
<div class="chapter">
<p class="calibre3"><span class="x-ebookmaker-pageno" id="pgepubid00013" title="[23]"><a id="Page_23"></a></span></p>
<h2 id="NEW_YEARS_DAY">NEW YEAR’S DAY</h2>
</div>
<div class="blockquot">
<p class="calibre3">AND THE PLACE IT FINDS US.—APPLES TO EAT AND AN OLD COMRADE
JOINS US.—MATTERS GETTING WORSE WITH OCCASIONAL
RUMORS OF EXCHANGE, ETC., ETC.</p>
</div>
<p class="calibre3">Jan. 1, 1864.—A great time this morning wishing one another a
Happy New Year. Robinson bought on the outside a dozen apples
and gave us all a treat. Nothing but corn bread to eat and very
poor quality. Dr. F. L. Lewis, Vet. Surg. 9th Mich. cavalry, came
in to-day; was captured at Dandridge, East Tennessee, where our
regiment had a severe engagement. Tells me all the news. Col.
Acker wounded, etc., etc. Thinks it a queer New Year trip, but
also thinks we will be exchanged before many weeks.</p>
<p class="calibre3">Jan. 2.—Rebel congress about to meet, and the people of Richmond
demand through the papers that the prisoners confined here
be removed immediately, as there is hardly enough for themselves
to eat, aside from feeding us “Northern Hirelings.” Hear of bread
riots and lots of trouble across the river. A big fire last night in
the vicinity of Libby Prison.</p>
<p class="calibre3">Jan. 3.—Received a letter from Michigan. Not quite so cold,
but disagreeable weather. Nine men bucked and gagged at one
time on the outside, two of them for stealing sour beans from a
swill-barrel. They would get permission to pass through the gate
to see the lieutenant, and instead, would walk around the cook-house
to some barrels containing swill, scoop up their hats full and
then run inside; but they were caught, and are suffering a hard
punishment for it.</p>
<p class="calibre3">Jan. 4.—Some ladies visited the island to see us blue coats, and
laughed very much at our condition; thought it so comical and
ludicrous the way the prisoners crowded the bank next the cook-house,<span class="x-ebookmaker-pageno" id="pgepubid00014" title="[24]"><a id="Page_24"></a></span>
looking over at the piles of bread, and compared us to wild
men, and hungry dogs. A chicken belonging to the lieutenant flew
up on the bank and was snatched off in short order, and to pay for
it we are not to receive a mouthful of food to-day, making five or
six thousand suffer for one man catching a little chicken.</p>
<p class="calibre3">Jan. 5.—Succeeded in getting Dr. Lewis into our tent; is rather
under the weather, owing to exposure and hardship. Jimmy Devers
spends the evenings with us and we have funny times talking
over better days—and are nearly talked out. I have said all I can
think, and am just beginning to talk it all over again. All our
stories have been told from two, to three or four times, and are getting
stale. We offer a reward for a good new story.</p>
<p class="calibre3">Jan. 6.—Still prisoners of war, without the remotest idea as to
how long we are to remain so. Some of the paroled Yankees on
the outside curse and treat the inside prisoners more cruel (when
they have a chance,) than the rebels themselves. Blass, a Spaniard,
who has been a prisoner over a year and refuses to be exchanged,
is the lieutenant’s right hand man. He tied up a man a few days
ago for some misdemeanor and whipped him. He is afraid to come
inside, knowing he would lose his life in a jiffy. He also raises
the rebel flag at the island mornings, and lowers it at night. It is
a dirty rag, and the appearance of it ought to disgust any sensible
person.</p>
<p class="calibre3">Jan. 7.—Rainy, cold and disagreeable weather. Henry Stilson,
a fellow who was captured with me, was carried out dead this
morning. He was diseased when taken, and fell an easy prey to
their cruelties. A good deal of raiding is going on among the men.
One Captain Moseby commands a band of cut-throats who do nearly
as they please, cheating, robbing and knocking down—operating
principally upon new prisoners who are unacquainted with prison
life. Moseby is named after the rebel guerrilla, his real name being
something else. He is from New York City, and is a regular bummer.</p>
<p class="calibre3">Jan. 8.—All taken outside to-day to be squadded over—an all
day job, and nothing to eat. The men being in hundreds and some
dying off every day, leave vacancies in the squads of as many as
die out of them, and in order to keep them filled up have to be
squadded over every few days, thereby saving rations. Richmond
papers are much alarmed for fear of a break among the prisoners
confined within the city. It is said there are six hundred muskets
secreted among the Belle Islanders. The citizens are frightened<span class="x-ebookmaker-pageno" id="pgepubid00015" title="[25]"><a id="Page_25"></a></span>
almost to death, double guards are placed over us, and very strict
orders issued to them.</p>
<p class="calibre3">Jan. 9.—A signal light suspended over the island all last night
for some reason unknown to the men confined here. We are cautioned
against approaching within eight or ten feet from the bank.
One of the raiders went through a man who lay near the bank and
started to run after robbing him. A guard who saw the whole
affair shot the villain dead and was applauded by all who knew of
the affair. Fifteen or twenty carried out this morning dead and
thirty or forty nearly so in blankets.</p>
<p class="calibre3">Jan. 10.—A brass band over to-day giving us a tune. Looks more
like a wandering tribe of vagabonds than musicians. Discoursed
sweet music, such as “Bonnie Blue Flag,” “The Girl I Left Behind
Me,” and for their pains got three groans from their enemies in
limbo. Dying off very fast on the island.</p>
<p class="calibre3">Jan. 11.—A steady rain for twenty-four hours, and have not been
dry during the time. However it is a warm rain and get along very
well. We are still issuing clothing but very slow. About one hundred
per day get partly clothed up. No news of exchange. Abe
Lincoln reported dead. Papers very bitter on Beast Butler, as they
call him. Manage by a good deal of skirmishing to get the papers
almost every day in which we read their rebel lies. A plan afoot
for escape, but am afraid to say anything of the particulars for fear
of my diary being taken away from me. As I came inside to-night
with some bread in my haversack some fellows who were on the
watch pitched into me and gobbled my saved up rations. I don’t
care for myself for I have been to supper, but the boys in the tent
will have to go without anything to eat for this night. It don’t
matter much—they are all hungry and it did them as much good as
it would our mess.</p>
<p class="calibre3">Jan. 12.—James River very high. A continual roar in our ears
caused by the water falling over the cataract just above the island.
Rebels fired a large shell over the prison to scare us.</p>
<p class="calibre3">Jan. 15.—Everything runs along about the same. Little excitements
from day to day. The weather is fair, and taken all together
thus far this winter has been very favorable to us as prisoners.
Lieut. Bossieux lost his dog. Some Yanks snatched him into a
tent and eat him up. Bossieux very mad and is anxious to know who
the guilty ones are. All he can do is to keep all our rations from
us one day, and he does it. Seems pretty rough when a man will
eat a dog, but such is the case.</p>
<p class="calibre3"><span class="x-ebookmaker-pageno" id="pgepubid00016" title="[26]"><a id="Page_26"></a></span></p>
<p class="calibre3">Jan. 18.—Too much exertion to even write in my diary. Talk of
getting away by escaping, but find no feasible plan. Rebs very
watchful. Some mail to-day but nothing for me. Saw some
papers, and a new prisoner brought with him a New York paper,
but not a word in it about “exchange.” Am still outside most every
day. Geo. Hendryx at work in the cook-house cooking rations for
the prisoners. Comes down where I am every day and hands me
something to take inside for the boys. He tells the Lieut. he has a
brother inside that he is feeding. Although it is against orders,
Lieut. Bossieux pays no attention to it.</p>
<p class="calibre3">Jan. 20.—Rebel officers over to-day inspecting us Yanks. Some
of the worst looking Arabs in shape of officers I ever saw. Jimmy
Devers comes to our tent every night and sits with us until bed
time. Is a jolly chap and keeps us all in good spirits with his
sayings. Sergt. Robinson, I learned to-day, instead of being a sergeant
is a lieutenant. His whole company being captured, he preferred
to go with them and share their trials, than go with the officers.
The men are very much attached to him and no wonder, as
he is a fine fellow. His home is in Sterling, Whiteside Co., Illinois.
Corp. McCartin is, as his name would indicate, an Irishman,
and his home is Louisville, Ky. Is a shoemaker by trade. He is
also a Mason, and I am going to write down wherein the fact of his
being a Mason has brought good into the camp to-day. The boys
feeling rather more hungry than usual were rather despondent, when
the corporal gets up and says: “Boys, I’ll go and get something to
eat.” Went out of the tent and in twenty minutes came back with
three or four pounds of bacon and two loaves of corn bread. We
were surprised and asked how he had performed the miracle. Told
us then that he was a Mason, as also was the lieutenant in charge,
from whom the food came. We decided then and there that the
first opportunity that presented itself we would join the Masons.
Can see the rebels drilling across the river.</p>
<p class="calibre3">Jan. 22.—Cold and clear weather. Nothing to write to-day. It’s
a task.</p>
<p class="calibre3">Jan. 24.—We are all troubled with heart-burn, sour stomach,
&amp;c. Drink weak lye made from ashes for it. Every day some new
ones come inside, but they know nothing as to the prospects of our
being exchanged. All are considerably surprised to find themselves
in quite so bad a place, and the subject of prison life begins to
interest them. Good deal of gambling going on among prisoners.
Chuck-a-luck is the favorite game. You lay your ration of bread<span class="x-ebookmaker-pageno" id="pgepubid00017" title="[27]"><a id="Page_27"></a></span>
down on a figure on a board, and a fellow with a dice-box shakes it
up a little, throws out the dice, and your bread is gone. Don’t
understand the game myself. That’s all I ever saw of the game.
Lay down the bread and it’s gone. Rather a one sided affair.
Some men are very filthy, which makes it disagreeable for those of
more cleanly habits. I believe that many, very many, who now
die, would live if they adopted the rules that our mess has, and
lived up to them. It is the only way to get along.</p>
<p class="calibre3">Jan. 25.—Being in this place brings out a man for just what he
is worth. Those whom we expect the most from in the way of
braving hardships and dangers, prove to be nobody at all. And
very often those whom we expect the least from prove to be heroes
every inch of them. Notably one of these is George Hendryx,
who is nothing but a good looking, effeminate boy, fit, you would
say, to be going to school with a mother to look after him, and for
not much else. But instead, he is brave, cheerful, smart, watching
every chance to get the best of the Johnny Rebs. His position
in the cook-house has given him a chance to feed, I presume, hundreds
of men. Near the cook-house is a store-house, and in it are
several hogsheads of hams. These hams were sent from the Sanitary
Commission at the North for Union prisoners, but they for
whom they were intended do not get them, and they are being eaten
up by the rebels. Hendryx has managed to get up a board in the
cook-house floor, where he can crawl fifteen or twenty feet under
the store-house and up through that floor. By this Yankee trick
he has stolen, I presume one hundred hams and gotten them inside
where they belong. This is very risky on his part, for should he
be discovered it would go very hard with him. He is about as
unselfish a fellow as you can well find. This is only one of his
plans to outwit the rebels for our benefit. His head is all the time,
too, planning some way of escape. Well, we all hope he won’t get
caught. All shake in our boots for him. Was on guard last night,
outside, over the clothing. There is so much clothing stole by the
rebels that Bossieux put a guard of two over the boxes through
the night, and if any of the Rebs. come around to steal we are
instructed to wake up the lieutenant, who sleeps near by in a tent.
I was on duty last night with Joe Myers, and Hendryx came where
we were and unfolded a plan for escape which he has been working
up. It is a risky affair, and had best be thought over pretty
thorough before put into execution. Robinson has been found out
as a lieutenant, and taken over to Richmond to be placed with the<span class="x-ebookmaker-pageno" id="pgepubid00018" title="[28]"><a id="Page_28"></a></span>
officers in Libby Prison. We are sorry that we must lose him.</p>
<p class="calibre3">Jan. 26.—Ninety-two squads of prisoners confined on less than
six acres of ground—one hundred in a squad, making nine thousand
and two hundred altogether. The lice are getting the upper
hand of us. The ground is literally covered with them. Bean soup
to-day and is made from the following recipe, (don’t know from
what cook book, some new edition): Beans are very wormy and
musty. Hard work finding a bean without from one to three bugs
in it. They are put into a large caldron kettle of river water and
boiled for a couple of hours. No seasoning, not even salt put into
them. It is then taken out and brought inside. Six pails full for
each squad—about a pint per man, and not over a pint of beans in
each bucket. The water is hardly colored and I could see clear
through to the bottom and count every bean in the pail. The men
drink it because it is warm. There in not enough strength or substance
in it to do any good. We sometimes have very good bean
soup when they have meat to boil with it.</p>
<p class="calibre3">Jan. 27.—More prisoners came to-day and say there is to be no
general exchange during the war, and we are to be sent off
into Georgia immediately. Stormy and disagreeable weather
and everybody down-hearted. Very still among the men, owing
to the bad news—hardly a word spoken by anybody. The least bit
off anything encouraging would change the stillness into a perfect
bedlam. I this morning looked into a tent where there were seventeen
men and started back frightened at the view inside. What a
tableau for a New York theatre? They were all old prisoners nearly
naked, very dirty and poor, some of them sick lying on the cold
ground with nothing under or over them, and no fire; had just been
talking over the prospect ahead and all looked the very picture of
dispair, with their hollow eyes, sunken cheeks and haggard expression.
I have before imagined such scenes but never before
realized what they were until now. And such is but a fair sample
of hundreds of men fully as bad.</p>
<p class="calibre3">Jan. 28.—No officers over from Libby for a few days past. Nearly
all the clothing issued. A few days more will close up the
clothing business, and then probably all the outsiders will be sent
inside; and for fear such will be the case we have decided upon
to-morrow night for the escape (which I have not said much about
in my diary). The nights are dark and cloudy. Messrs. Mustard
and Hendryx both sleep outside now, and I must manage to, both
to-night and to-morrow night. I have been two weeks trying to get<span class="x-ebookmaker-pageno" id="pgepubid00019" title="[29]"><a id="Page_29"></a></span>
a map of Virginia, and have at last succeeded. A negro brought it
to me from the city. It has cost over thirty dollars Confederate
money—at the North would have cost twenty-five cents. I would
not take for it, unless I could get another one, one thousand dollars
in gold. We are well rigged, have some food saved up to take
along; in good health and determined to get away. Lieut. Bossieux
suspects, and to-day took the pains to say in our hearing that
he knew an escape among the outsiders was in view, and as sure as
there was a God in heaven if we tried it and got caught, and we
surely would be, he would first shoot all he could before catching
us, and the balance would be tied up and whipped every day until
he got tired, as long as we lived. We must expect trouble. It
does not change us in the least; if anything, makes us the more
determined to get away. To-night we are to start, and I will write
down the plans we have, running the risk of the rebels getting hold
of it. At a few moments past eleven and before midnight the
guard will let us cross his beat and go to the water’s edge. We all
have rebel clothing which we are to wear, furnished partly by a
negro, and partly by the guard who helps us off. We take the
quarter-master’s boat, which we unlock, and having been furnished
the countersign give it to the picket who will pretend that he
thinks we are rebel guards going over to the city, in case we are
caught, which will screen him in a measure. Having passed him,
we get into the boat and row across the river, give the countersign
to the guards on the other side of the river, and talk with them a
little, being ourselves posted on general information regarding the
place. To quiet their suspicions if they have any, we then start
up into the town and when out of sight of the guards take a turn
to the left, and go straight to the Richmond jail; taking care to
avoid patrols &amp;c. We will then meet with a negro who will guide
us ten miles up the river, and then leave us in charge of friendly
blacks who will keep us through the next day and at night pilot
us farther along toward our lives. If possible, I shall steal the
rebel flag, which is kept nights in the lieutenant’s tent, and a few
other relics, to take along with me. The big bell in Richmond
strikes six, and we close our diary, hoping never to look upon it
again until we return to free our fellow prisoners, with the glorious
army of the North. Now we leave our diary to finish preparations
for the flight for freedom. May God aid us in this land
of tyranny, where we have met nothing but suffering. Good bye,
Belle Isle and Prison. Hail! Freedom, Home, Friends, and the<span class="x-ebookmaker-pageno" title="[30]"><a id="Page_30"></a></span>
Grand Army of the Old Flag! What is in store for us in the future?</p>
<p class="calibre3">Feb. 5.—Have been reading over the last few pages of my diary.
It sounds well, but the rebel flag still floats over Belle Isle. Our
escapade was a grand fizzle, and all hands have been punished in
more ways than one in the last few days. Bossieux suspected
something going on among us and had us secretly watched, and
long before we had made a move toward fulfilling our projected
plans we were thrown into a guard house on the island; next morning
taken out of it, and underwent a severe cross-questioning. He
found our rebel clothing, food we had packed, found the lock to
the boat broke, and numerous other signs of an abandonment.
Well, the result has been that we were bucked and gagged twice a
day for an hour each time, and for four hours each of us carried a
big stick of wood up and down in front of the gate, a guard to
prick us with his bayonet if we walked too slow to suit him. Then
Hendryx has been strung up by the thumbs. Nights we have been
thrown into a damp, cold guard house to shiver all night. Every
day now for six days we have walked with our sticks of wood so
many hours per day, and last night were turned inside with all the
prisoners to stay, Bossieux says, till we <em>rot</em>, he can place no
dependence in us.</p>
<p class="calibre3">Feb. 6.—We have to laugh over our trials and tribulations.
Where we had plenty a week ago, plenty of exercise, and many
favors, we are now right where we were at first, fareing just as the
rest, with no favors shown us. It’s all right, we can stand it just
as well as the rest. We have never belittled ourselves in the least
in our dealings with the rebels. Bossieux told us himself, as we
came inside, that he didn’t blame us in the least for trying to get
away, but he was obliged to punish us for the attempt. Hendryx
says that he will be out again in three days.</p>
<p class="calibre3">Feb. 8.—Butler reported as commissioner on exchange and the
rebels declare that they would never recognize him and would rather
that we should all die here than negotiate with the Beast. Congress
still in session over in the city and we watch the papers eagerly
for something relative to us. The Holy Sabbath day and the
church bells ringing for morning service. Don’t think I shall attend
this morning; it is such a long walk and then I look so bad;
have nothing fit to wear. A man stabbed a few minutes ago by his
tent mate, killing him instantly. They had all along been the best
friends until a dispute arose, and one of them drew a knife and
killed his comrade. Strong talk of lynching the murderer. Have<span class="x-ebookmaker-pageno" id="pgepubid00020" title="[31]"><a id="Page_31"></a></span>
not heard the particulars. Corp. McCartin is missing from the island
and am confident from what I have seen that he has escaped
and by the help of Lieut. Bossieux. No endeavors are being made
to look him up, still he offers a reward for his apprehension. They
are both members of the secret craft.</p>
<p class="calibre3">Feb. 9.—Great news this morning. A raid is being made on
Richmond by Kilpatrick. Rebels manning their forts in sight of
us. All are at work, women, children, in fact everybody who can
shovel. No cars running over the big bridge. Double guards
placed over us and the greatest activity prevails among them. It is
really amusing to see them flying around and many are the jokes
at their expense. All business is suspended in Richmond; no papers
issued, and everybody with their guns or working utensils.
Brass bands are playing their best to encourage the broken down
Confederacy. A portion of the congress came over this afternoon
to take a look at us, among whom were Davis, Benjamin and Howell
Cobb. They are a substantial looking set of men and of the
regular southern cut. The broad brim hats, gold headed canes and
aristocratic toss of the head, alone would tell who they were. They
are a proud, stern set of men and look as if they would like to
brush us out of existence. Still we are not going to be brushed out
so easy and they found men among us who were not afraid to stare,
or hold our heads as high as their lordships. A band accompanied
them and played the Bonnie Blue Flag, which was hissed and groaned
at by the Yankees, and in return a thousand voices sang Yankee
Doodle, very much to their discomfiture.</p>
<p class="calibre3">Feb. 10.—The hospital signal lights suspended over the island all
night in order to direct the batteries where to aim their pieces in
case of an outbreak which is greatly feared. Rockets sent up at
intervals during the night over Richmond. Reported that there
are six hundred muskets secreted among the prisoners and citizens
very much alarmed and afraid of us. I hope there is but cannot
believe it. It is impossible for me to sleep and I lay awake thinking
how we are situated and wondering how long the play is to
last.</p>
<p class="calibre3">Feb. 11.—Cold and pleasant. A good deal of fighting going on
among us—a discontented set of beings; just like so many hungry
wolves penned up together. Rebels still at work fortifying all
around Richmond. A number of Yankees have been taken out on
parole of honor to work building breastworks etc., but a very few
will go and it is considered a great crime among us to work for<span class="x-ebookmaker-pageno" id="pgepubid00021" title="[32]"><a id="Page_32"></a></span>
them. Have they forgotten our existence at the North? It seems
as if we were neglected by our government but will not judge them
hastily until we know more. There are perhaps sufficient reasons
for our remaining here. Very strongly guarded, nevertheless we
talk of escape and are all the while building air castles.</p>
<p class="calibre3">Feb. 12.—Lieut. Bossieux has sent a squad of men from the island
composed of runaways over to Castle Thunder to remain during
the war as hostages, among whom were our friends Myers and
Mustard. I never expect to see them again.</p>
<p class="calibre3">Feb. 13.—Very cold. The rebels are again settling down and getting
over their scare. Not much to eat now and the men more disheartened
than ever. A rebel preacher delivered us a sermon of
two hours length from a dry goods box. He was listened to attentively
and made the remark before closing that he didn’t know as
he was doing any good talking to us. It was like casting pearls before
swine and he would close his remarks, to which a Yankee told
him he might have stopped long ago if he had wanted to; no one
would have made any objections. Was told that six hundred are
to start for Georgia to-day and subsequently six hundred every day
until all are removed from Richmond. Lieut. Bossieux says it is
so but there is going to be an exchange of sick in a few days and all
outside hands shall be sent north with them.</p>
<p class="calibre3">Feb. 14.—Had quite an adventure last night with the raiders.
One of Capt. Moseby’s robbers was trying to steal a blanket from
our tent by reaching through the tent opening when Dad (E. P.
Sanders), who is always awake, threw a brick hitting him on the
arm, breaking the brick, and as he jumped, halloed to us, “Come
boys, let’s catch the rascal,” and out of the door he went. Dr. and
myself nobly rushed to the rescue and reached the door just in
time to see Dad turn a short corner way up the street and close on
to the heels of Mr. Robber, but he slipped and fell and the thief got
away. Were soon snugly ensconced in bed once more congratulating
ourselves on losing nothing as we thought. But on getting up
this morning I found my shoes gone and am barefoot in the middle
of winter. However I can get more and have no fear on that
score. Six hundred sent away to-day, some say to our lines while
others think to Georgia. Rebels say to our lines, and that a general
exchange has been agreed upon. Great excitement among the men.
Evening.—Lieut. Bossieux called me outside just before night and
told me he was called upon to furnish some hostages to be sent to
Charleston to be kept during the war, and had decided to send<span class="x-ebookmaker-pageno" id="pgepubid00022" title="[33]"><a id="Page_33"></a></span>
Hendryx and myself, with some others. Said it was better to send
those who were always trying to get away. Have succeeded in
buying a pair of shoes, which, although about four sizes too large,
are much better than none. Thanks to the Sanitary Commission I
have good woolen stockings, under clothing complete, and am
otherwise well dressed. Six hundred sent away this afternoon
under a very strong guard, which does not look like an exchange.</p>
<p class="calibre3">Feb. 17.—Still on the island. Another squad taken out yesterday.
It will not be our turn to go for some days, even if six
hundred are taken out every day. Have not been sent for as hostages
yet. Hendryx and myself have decided to flank out and go
with the next that go, no matter where their destination may be.
If we don’t get away, with a ghost of a chance, then it will be
funny.</p>
<p class="calibre3">Feb. 20.—All sorts of rumors afloat, but still we stay here.
Strange officers come over and look at us. Bossieux away considerable,
and something evidently up. Anything for a change.
My health is good, and tough as a bear.</p>
<p class="calibre3">Feb. 23.—None have been taken away from the island for a
number of days. Have heard that a box came for me, and is over
in Richmond. Hope the rebel that eats the contents of that box
will get choked to death. I wrote to the Governor of Michigan,
Austin Blair, who is in Washington, D. C., some weeks ago. He
has known me from boyhood. Always lived in the neighborhood
at Jackson, Mich. Asked him to notify my father and brothers of
my whereabouts. To-day I received a letter from him saying that
he had done as requested, also that the Sanitary Commission had
sent me some eatables. This is undoubtedly the box which I have
heard from and is over in Richmond. Rebels are trying to get
recruits from among us for their one-horse Confederacy. Believe
that one or two have deserted our ranks and gone over. Bad luck
to them.</p>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// Section0006.vue?49a55558